import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

interface MessagePopupProps {
    message: string;
    onClose: () => void;
}

const MessagePopup: React.FC<MessagePopupProps> = ({ message, onClose }) => {
    return (
        <Dialog open={true} onClose={onClose}>
            <DialogTitle></DialogTitle>
            <DialogContent>
                <DialogContentText>
                    <p>{message}</p>
                </DialogContentText>
            </DialogContent>
            <DialogActions>

                <Button variant="contained"
                    color="primary"
                    onClick={onClose}
                    //sx={{ background: '#0afc7f',color:'#000' }}
                    >
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default MessagePopup;
